// extracted by mini-css-extract-plugin
export default {"headerContainer":"style_headerContainer__Rww8+","title":"style_title__es2u8","menuWrapper":"style_menuWrapper__H2fEg","menu":"style_menu__pTew3","item":"style_item__iMcI0"};